import { fillZipCode, getNameStreet } from 'src/app/utils/normalizerFunctions';

export class Operation {
    private formularioNormalizacion = null;
    private formularioResultadoCobertura = null;
    private userData = null;
    private bankData = null;
    private preActivationData = null;
    private orderIdDraft = null;
    private itemForms = [];
    private pdv = null;
    private datosTipoVia: any;

    constructor() { }

    getAll() {
        return {
            formularioNomralizacion: this.formularioNormalizacion,
            formularioResultadoCobertura: this.formularioResultadoCobertura,
            itemForms: this.itemForms,
            userData: this.userData,
            bankData: this.bankData,
            pdv: this.pdv,
        };
    }

    getFormularioNormalizacion() {
        return this.formularioNormalizacion;
    }

    getFormularioResultadoCobertura() {
        return this.formularioResultadoCobertura;
    }

    getUserData() {
        return this.userData;
    }

    getBankData() {
        return this.bankData;
    }

    getOrderId() {
        return this.orderIdDraft;
    }

    setFormularioNormalizacion(formularioNormalizacion) {
        this.formularioNormalizacion = formularioNormalizacion;
    }

    setFormularioResultadoCobertura(formularioResultadoCobertura) {
        this.formularioResultadoCobertura = formularioResultadoCobertura;
    }

    setUserData(userData) {
        this.userData = userData;
    }

    setBankData(bankData) {
        this.bankData = bankData;
    }

    setPreActivationData(data) {
        this.preActivationData = data.getRawValue();
    }

    setPdv(pdv) {
        this.pdv = pdv;
    }

    setOrderId(id) {
        this.orderIdDraft = id;
    }

    getItemForms() {
        return this.itemForms;
    }

    setDatosVia(datosTipoVia) {
        this.datosTipoVia = datosTipoVia;
    }

    addItemForm(form) {
        let found = false;
        for (let i = 0; i < this.itemForms.length; i++) {
            if (this.itemForms[i].get('stepper_index').value === form.get('stepper_index').value) {
                found = true;
                this.itemForms[i] = form;
                break;
            }
        }
        if (!found) {
            this.itemForms.push(form);
        }
    }

    removeItemForm(index) {
        this.itemForms.splice(index, 1);
    }

    generateOrders() {
        const user = this.userData.getRawValue();
        const bank = this.bankData.getRawValue();
        const cobertura = this.formularioResultadoCobertura === null ? null : this.formularioResultadoCobertura.getRawValue();
        const normaliza = this.formularioNormalizacion === null ? null : this.formularioNormalizacion.getRawValue();
        const id_order = this.orderIdDraft;
        const items = [];
        for (const itemForm of this.itemForms) {
            items.push(itemForm.getRawValue());
        }

        let order: any;
        order = {
            rate_id: items[0].rate.rate_id,
            draft: '',
            order_id: id_order !== null ? id_order : '',
            customer: {
                name: user.firstName,
                last_name: user.surname1,
                second_last_name: user.surname2,
                phone_number: user.phone,
                email: user.email,
                document_type: user.doctype,
                document: user.doc,
                nationality: user.country,
                birth_date: (typeof user.birthday === 'object') ? user.birthday.format('YYYY-MM-DD') : user.birthday,
                gender: user.sex === 'M' ? 'male' : 'female',
                payment: {
                    iban: bank.bank_account && bank.bank_account !== '' ? bank.bank_account.replace(/ +?/g, '') : '',
                    bank_name: '',
                    document_type: bank.account_doctype,
                    document: bank.account_doc,
                    name: bank.account_firstName,
                    last_name: bank.account_surname1,
                    second_last_name: bank.account_surname2
                },
                postal_address: this.getUserAddress(user),
                billing_address: this.getUserAddress(user),
            },
            mobiles: this.getMobile(items),
            pdv: {
                sfid: this.pdv.sfids.amena,
                telesales: this.pdv.info.telesales,
                third_party_verification: this.getVPT(items[0].type_operation),
                without_logistic: this.getLogistica(items[0]),
                fixSfid: this.pdv.sfids.amena_fijo
            },
            agreements: {
                privacy_policy: true,
                third_party_data_transfer: this.preActivationData.third_party_data_transfer,
                data_treatment: this.preActivationData.data_treatment,
                commercial_communications: this.preActivationData.commercial_communications,
                third_party_commercial_communications: this.preActivationData.third_party_commercial_communications,
                orange_companies_data_transfer: this.preActivationData.orange_companies_data_transfer,
                consent: true
            },
            campaign: this.preActivationData.campaign_code
        };
        //// CAMPOS OPCIONALES
        // si lleva linea fija
        if (cobertura !== null) {
            let technology = '';
            if (items[0].rate.hasOwnProperty('access')) {
                technology = items[0].rate.access;
            } else if (cobertura.resultadoConsultaCobertura.hasOwnProperty('access')) {
                technology = cobertura.resultadoConsultaCobertura.access;
            }
            order.broadband = {
                technology_access: technology,
                msisdn: cobertura.portabilidadFijo, // Número fijo a portar
                service_provider_id: cobertura.serviceProviderFijo, // Operador desde el cual se va a portar
                cima_arvato_code: cobertura.resultadoConsultaCobertura.cimaArvatoCode,
                cima_ine_town_code: cobertura.resultadoConsultaCobertura.cimaINETownCode,
                cima_gescal_code: cobertura.resultadoConsultaCobertura.cimaGescalCode,
                cima_unique_entity: cobertura.resultadoConsultaCobertura.cimaUniqueEntity,
                cima_portal_code: cobertura.resultadoConsultaCobertura.cimaPortalCode,
                miga_code: cobertura.resultadoConsultaCobertura.migaCode,
                cima_block_code: cobertura.resultadoConsultaCobertura.cimaBlockCode,
                cima_bis_code: cobertura.resultadoConsultaCobertura.cimaBisCode,
                cima_stair_code: cobertura.resultadoConsultaCobertura.cimaStairCode,
                cima_stair_other_code: cobertura.resultadoConsultaCobertura.cimaStairOtherCode,
                cp_vat: cobertura.cp_vat ? cobertura.cp_vat : null,
                cp_price: cobertura.cp_price ? cobertura.cp_price : null,
                cp_price_without_vat: cobertura.cp_price_without_vat ? cobertura.cp_price_without_vat : null,
                
            };
            // si se instala fijo
            order.customer.installation_address = this.getNormalizedOrUserAddress(cobertura, normaliza, user);
        }

        // entrega movil
        if (user.terminal_delivery && user.terminal_delivery.courierData) {
            const courier = user.terminal_delivery.courierData;
            order.customer.delivery_address = {
                country: 'Spain',
                province: courier.province,
                city: courier.city,
                name: courier.full_name,
                phone_number: courier.phone,
                post_code: fillZipCode(courier.zip),
                street_type: this.getTypeStreet(courier.road_type),
                street_name: getNameStreet(courier.address, this.datosTipoVia, 'code'),
                street_number: `${courier.number}`,
                staircase_number: courier.stairway,
                floor_number: courier.floor,
                apartment_number: courier.door,
                additional_info: courier.additional_info
            };
        }

        // entrega PDV
        if (user.terminal_delivery && user.terminal_delivery.pdvData) {
            const pdv = user.terminal_delivery.pdvData;

            order.customer.delivery_address = {
                country: 'Spain',
                province: pdv.address.province,
                city: pdv.address.location,
                name: pdv.info.name,
                phone_number: pdv.info.phone,
                post_code: fillZipCode(pdv.address.postCode),
                street_type: '',
                street_name: getNameStreet(pdv.address.address, this.datosTipoVia, 'code'),
                street_number: '',
                staircase_number: '',
                floor_number: '',
                apartment_number: ''
            };
        }

        // si se entrega en correos
        if (user.terminal_delivery && user.terminal_delivery.mailData) {
            const correos = user.terminal_delivery.mailData;
            order.correos = {
                id: correos.id,
                name: correos.name,
                street_number: correos.address.streetNr,
                street_name: getNameStreet(correos.address.streetName, this.datosTipoVia, 'code'),
                street_type: this.getTypeStreet(correos.address.streetType),
                post_code: fillZipCode(correos.address.postcode),
                city: correos.address.city,
                province: correos.address.stateOrProvince,
                complete_address: correos.address.completeAddress,
                calendar: [],
                geographic_sub_address: []

            };
            for (const day of correos.calendar) {
                order.correos.calendar.push(
                    {
                        status: '',
                        day: day.day,
                        opening_times: day.openingTimesDescription,
                        hour_period: day.hourPeriod
                    }
                );
            }

            for (const subaddress of correos.address.geographicSubAddress) {
                order.correos.geographic_sub_address.push(
                    {
                        id: subaddress.id,
                        level_number: subaddress.levelNumber,
                        door: subaddress.door,
                        staircase: subaddress.staircase
                    }
                );
            }
        }


        // entrega al cliente
        if (user.terminal_delivery && user.terminal_delivery.type === 3) {
            order.customer.delivery_address = {
                country: 'Spain',
                province: user.provincia,
                city: user.localidad,
                name: user.firstName + ' ' + user.surname1 + ' ' + user.surname2,
                phone_number: user.phone,
                post_code: fillZipCode(user.codigoPostal),
                street_type: this.getTypeStreet(user.tipoVia),
                street_name: getNameStreet(user.nombreVia, this.datosTipoVia, 'code'),
                street_number: `${user.numero}`,
                staircase_number: user.escalera,
                floor_number: user.planta,
                apartment_number: user.puerta
            };
        }

        return order;
    }

    getNormalizedOrUserAddress(cobertura, normaliza, user) {
        if (cobertura !== null && normaliza !== null) {
            return {
                country: 'Spain',
                province: cobertura.provinciaCobertura,
                city: cobertura.localidadCobertura,
                post_code: fillZipCode(cobertura.codigoPostalCobertura),
                street_type: this.getTypeStreet(cobertura.tipoViaCobertura),
                street_name: cobertura.nombreViaCobertura,
                street_name2: '',
                street_number: cobertura.numeroCobertura,
                staircase_number: cobertura.escaleraCobertura,
                floor_number: cobertura.plantaCobertura,
                apartment_number: cobertura.puertaCobertura
            };
        } else {
            return this.getUserAddress(user);
        }
    }

    getUserAddress(user) {
        return {
            country: 'Spain',
            province: user.provincia,
            city: user.localidad,
            post_code: fillZipCode(user.codigoPostal),
            street_type: this.getTypeStreet(user.tipoVia),
            street_name: getNameStreet(user.nombreVia, this.datosTipoVia, 'code'),
            street_name2: '',
            street_number: `${user.numero}`,
            staircase_number: user.escalera,
            floor_number: user.planta,
            apartment_number: user.puerta
        };
    }

    getVPT(tipo_alta) {
        let digo_vpt = null;

        if (this.pdv.permissions.AMENA_VPT === 'NECESARIO_ENVIO_SMS') {
            digo_vpt = true;
        } else if (this.pdv.permissions.AMENA_VPT === 'NO_NECESARIO_ENVIO_SMS') {
            digo_vpt = false;
        } else if (this.pdv.permissions.AMENA_VPT === 'NECESARIO_ENVIO_SMS_PARA_ALTA' && (tipo_alta === 'registration' || tipo_alta === 'registration_logistica')) {
            digo_vpt = false;
        } else if (this.pdv.permissions.AMENA_VPT === 'NECESARIO_ENVIO_SMS_PARA_PORTABILIDADES' && tipo_alta === 'portability_logistica') {
            digo_vpt = true;
        } else {
            digo_vpt = false;
        }

        return digo_vpt;
    }

    getLogistica(item) {
        let permiso_logistica = null;
        if (item.hasOwnProperty('iccid')) {
            if (item.iccid !== null && item.iccid !== '') {
                permiso_logistica = true;
            } else {
                permiso_logistica = false;
            }
        } else {
            permiso_logistica = false;
        }

        return permiso_logistica;
    }

    getMobile(items) {
        const mobile = [];
        let tmp;

        items.forEach((item, index) => {
            tmp = {
                msisdn: item.portability_phone,
                old_iccid: item.portability_iccid ? item.portability_iccid : '',
                old_contract_type: item.portability_type_client ? item.portability_type_client : '',
                new_iccid: item.iccid ? item.iccid : '',
                terminal_id: item.terminal ? item.terminal.terminal_id : '',
                terminal_vap: item.terminal_payment_type === 'VAP',
                principal: index === 0,
                rate_id: item.rate.rate_id,
                service_provider_id: item.portability_operator ? item.portability_operator : '',
                resegmentation: item.resegmentation ? item.resegmentation : '',
                resegmentation_from_type: item.resegmentation_from_type ? item.resegmentation_from_type : '',
                resegmentation_type: item.resegmentation_type ? item.resegmentation_type : '',
                delivery_method: item.type_operation ? item.type_operation : '',
                cp_vat: item.cp_vat ? item.cp_vat : null,
                cp_price: item.cp_price ? item.cp_price : null,
                cp_price_without_vat: item.cp_price_without_vat ? item.cp_price_without_vat : null,
            };
            mobile.push(tmp);
        });

        return mobile;
    }

    getTypeStreet(value: string): string {
        if (this.datosTipoVia && this.datosTipoVia.length && value) {
            if (value.toLowerCase() === 'passatge') {
                value = 'pasaje';
            }
            const valueNormalized = value.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

            const tipoVia = this.datosTipoVia.filter(item => {
                const codeNormalized = item.code.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');

                return valueNormalized.toLowerCase() === codeNormalized.toLowerCase();
            });

            if (tipoVia && tipoVia.length) {
                const code = tipoVia[0].code;

                return code;
            } else {
                return 'CALLE';
            }
        }

        return 'CALLE';
    }
}
